var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 39,
    viewBox: "0 0 52 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6708 0L12.5963 28.3763L10.6584 20.2688C13.7805 20.2688 16.3644 21.1075 18.4099 22.7849C20.4555 24.4624 21.4783 26.6989 21.4783 29.4946C21.4783 32.2903 20.4555 34.5735 18.4099 36.3441C16.3644 38.1147 13.8344 39 10.8199 39C7.69772 39 5.11387 38.1147 3.06832 36.3441C1.02277 34.4803 0 32.1971 0 29.4946C0 28.5627 0.0538304 27.6774 0.161491 26.8387C0.376812 26 0.699793 25.0215 1.13043 23.9032C1.56108 22.6918 2.15321 21.2473 2.90683 19.5699L10.4969 0H20.6708ZM51.1925 0L43.118 28.3763L41.1801 20.2688C44.3023 20.2688 46.8861 21.1075 48.9317 22.7849C50.9772 24.4624 52 26.6989 52 29.4946C52 32.2903 50.9772 34.5735 48.9317 36.3441C46.8861 38.1147 44.3561 39 41.3416 39C38.2195 39 35.6356 38.1147 33.5901 36.3441C31.5445 34.4803 30.5217 32.1971 30.5217 29.4946C30.5217 28.5627 30.5756 27.6774 30.6832 26.8387C30.8985 26 31.2215 25.0215 31.6522 23.9032C32.0828 22.6918 32.6749 21.2473 33.4286 19.5699L41.0186 0H51.1925Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.d5917bc0a7c209705adb40986d063b1e.svg";
export { ForwardRef as ReactComponent };